
<section class="content-modal-url-doc">
    <button class="icon-close" (click)="closeModal()" >
        <mat-icon>close</mat-icon>
      </button>

   <div class="content-modal-url-doc-form">
    <form [formGroup]="form">
        <div class="laureate-input-group">

            <label for="url"> URL </label>

            <input matInput type="text" id="url" formControlName="URL" [readonly]="true" >

            <div class="copy" >
              <app-copy [value]="getValue('URL')" > </app-copy>
            </div>

          </div>
    </form>
   </div>
</section>
